import { GenericSearch } from 'components/PillSearch';
import * as React from 'react';
import { useFilterSearchParams } from '../../hooks';

export const Search: React.FC = () => {
  const { searchParams, setSearchParams } = useFilterSearchParams(true);
  return (
    <GenericSearch
      onSearch={(values) => setSearchParams({ bols: values })}
      inputValues={searchParams.bols}
      maximum={100}
      placeholder="Filter by Ocean BOL"
      className="w-[400px]"
      variant="magnifying-glass"
    />
  );
};
Search.displayName = 'Shipments.AddContainers.RecentlyAdded.Search';
